import { ComponentParams, Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  TranslationOptionsParams,
  AnchorTargetParams,
  RenderingProps,
} from 'src/shared/shared.types';

export type F01FormProps = RenderingProps<F01FormFields, F01FormParams> & {
  formioProjectUrl?: string;
  formioScript?: string;
};

export type F01FormFields = {
  FormName?: Field<string>;
  ThankYouPageUrl?: LinkField;
  params?: ComponentParams;
};

export type F01FormParams = ComponentParams & TranslationOptionsParams & AnchorTargetParams;
